export default "__VITE_ASSET__9vhWoYbc__"